import React, { useState } from 'react'
import { DataGrid as MUIDataGrid, DataGridProps } from '@mui/x-data-grid'
import { ProfessionalAthlete } from 'models/interfaces/professional-athlete.interface'

type Props = DataGridProps & {
  setProfessionalAthletesSelectedToCopy: any
  rows: ProfessionalAthlete[]
}

export const DataGridSelectAthleteToCopy = ({ setProfessionalAthletesSelectedToCopy, rows, ...rest }: Props) => {
  const [pageSize, setPageSize] = useState<number>(20)

  return (
    <MUIDataGrid
      {...rest}
      style={{
        borderTopWidth: 0.5,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderRadius: 0
      }}
      rows={rows}
      autoHeight={true}
      rowHeight={65}
      rowsPerPageOptions={[20, 40, 80]}
      checkboxSelection
      pagination
      pageSize={pageSize}
      disableColumnMenu={true}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      onSelectionModelChange={(ids) => {
        const selectedIDs = new Set(ids)
        const selectedRows: ProfessionalAthlete[] = rows.filter((row) =>
          selectedIDs.has(row.id)
        )
        setProfessionalAthletesSelectedToCopy(selectedRows)
      }}
    />
  )
}
